/* ASYCO 2 AI - "Completa tu compra" en el CARRITO DESLIZABLE (drawer). Lee /cart.js,
   toma el ultimo item y trae complementos (otra categoria) via /recommendations/products.json.
   Monta en .asyco-drawer-recs (en cart-summary, compartido) pero por CSS solo se ve DENTRO
   del drawer (en la pagina /cart ya hay una fila de recos). Quick-add via /cart/add.js.
   SIN precio (el de /recommendations es Shopify, puede no coincidir con CRM; al agregar,
   el carrito muestra el precio real). */
(function () {
  'use strict';
  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function imgU(u) { if (!u) return ''; if (u.slice(0, 2) === '//') u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
  function getJSON(u) { return fetch(u, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function firstAvail(p) { var v = (p.variants || []).filter(function (x) { return x.available; })[0]; return v && v.id; }

  function render(mount, list) {
    var sig = list.map(function (p) { return p.id; }).join(',');
    if (mount.getAttribute('data-recs') === sig) return;
    mount.setAttribute('data-recs', sig);
    mount.innerHTML = '<div class="asyco-dr__h">Completa tu compra</div><div class="asyco-dr__row">' +
      list.map(function (p) {
        var vid = firstAvail(p), img = p.featured_image || (p.images && p.images[0]) || '';
        return '<div class="asyco-dr__card"><a class="asyco-dr__lnk" href="/products/' + p.handle + '">' +
          '<img class="asyco-dr__img" loading="lazy" src="' + imgU(img) + '" alt="' + esc(p.title) + '">' +
          '<span class="asyco-dr__t">' + esc(p.title) + '</span></a>' +
          '<button type="button" class="asyco-dr__add" data-vid="' + vid + '">Agregar</button></div>';
      }).join('') + '</div>';
  }

  function populate(mount) {
    getJSON('/cart.js').then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) { mount.innerHTML = ''; mount.setAttribute('data-recs', '0'); return; }
      var inCart = {}; cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
      var last = cart.items[cart.items.length - 1];
      var ptype = (last.product_type || '').toLowerCase();
      getJSON('/recommendations/products.json?product_id=' + last.product_id + '&intent=related&limit=10').then(function (d) {
        var recs = (d && d.products) || [];
        var pool = recs.filter(function (p) { return !inCart[p.id] && (p.variants || []).some(function (v) { return v.available; }); });
        var diff = pool.filter(function (p) { return (p.type || '').toLowerCase() !== ptype; });
        var list = (diff.length >= 2 ? diff : pool).slice(0, 3);
        if (list.length < 1) { mount.innerHTML = ''; mount.setAttribute('data-recs', '0'); return; }
        render(mount, list);
      });
    });
  }

  function tick() { [].slice.call(document.querySelectorAll('.asyco-drawer-recs')).forEach(function (m) { if (!m.getAttribute('data-recs')) populate(m); }); }
  var refresh = tick;
  // Rafaga ACOTADA de ticks: cubre el morph in-place del drawer al abrirse, SIN polling eterno.
  var burstT = null;
  function burst() { var n = 0; clearTimeout(burstT); (function go() { tick(); if (++n < 6) burstT = setTimeout(go, 350); })(); }
  function forceRefresh() { [].slice.call(document.querySelectorAll('.asyco-drawer-recs')).forEach(function (m) { m.removeAttribute('data-recs'); }); burst(); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.asyco-dr__add'); if (!b) return;
    var vid = b.getAttribute('data-vid'); if (!vid || vid === 'undefined') return;
    b.disabled = true; b.textContent = 'Agregando...';
    // Section Rendering API: pedir las secciones de los cart-items para que el tema (Horizon) refresque el drawer.
    var sids = [].slice.call(document.querySelectorAll('cart-items-component')).map(function (el) { return el.dataset.sectionId; }).filter(Boolean);
    var body = { items: [{ id: Number(vid), quantity: 1 }] };
    if (sids.length) { body.sections = sids.join(','); body.sections_url = location.pathname; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (resp) {
        // disparar el evento NATIVO del tema (cart:update) con las secciones -> cart-items-component morphea el drawer + el icono se actualiza
        var ev;
        try { ev = new Event('cart:update', { bubbles: true }); ev.detail = { resource: resp, sourceId: 'asyco-drawer-recs', data: { source: 'asyco-drawer-recs', sections: resp.sections } }; }
        catch (_) { ev = new CustomEvent('cart:update', { bubbles: true, detail: { resource: resp, sourceId: 'asyco-drawer-recs', data: { source: 'asyco-drawer-recs', sections: resp.sections } } }); }
        document.dispatchEvent(ev);
        b.textContent = 'Agregado';
        setTimeout(forceRefresh, 700);
      })
      .catch(function () { b.textContent = 'Reintentar'; b.disabled = false; });
  });

  function findDrawer() { return document.querySelector('cart-drawer-component, cart-drawer, .cart-drawer, #cart-drawer, dialog.cart-drawer'); }

  function boot() {
    var css = '.asyco-drawer-recs{display:none}'
      + '.cart-drawer__dialog .asyco-drawer-recs,cart-drawer-component .asyco-drawer-recs{display:block;margin:2px 0 14px}'
      + '.asyco-dr__h{font-weight:700;font-size:.95rem;margin:0 0 8px}'
      + '.asyco-dr__row{display:flex;gap:10px;overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none;scroll-snap-type:x proximity;-webkit-overflow-scrolling:touch}'
      + '.asyco-dr__row::-webkit-scrollbar{display:none}'
      + '.asyco-dr__card{flex:0 0 116px;scroll-snap-align:start;border:1px solid rgba(0,0,0,.1);border-radius:10px;overflow:hidden;background:#fff;display:flex;flex-direction:column}'
      + '.asyco-dr__lnk{text-decoration:none;color:inherit;display:flex;flex-direction:column}'
      + '.asyco-dr__img{width:100%;aspect-ratio:1/1;object-fit:contain;background:#fff}'
      + '.asyco-dr__t{font-size:.74rem;line-height:1.2;padding:7px 8px 0;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.2em}'
      + '.asyco-dr__add{margin:7px 8px 8px;border:0;border-radius:7px;background:#e1242a;color:#fff;font-weight:700;font-size:.78rem;padding:9px;min-height:42px;line-height:1.1;cursor:pointer}'
      + '.asyco-dr__add:disabled{opacity:.7}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    tick();
    // SIN setInterval eterno: refrescos dirigidos por EVENTOS del tema + apertura del carrito.
    ['cart:update', 'cart:refresh', 'cart:updated', 'on:cart:update', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, forceRefresh); });
    // Abrir el carrito (icono/toggle/add) -> rafaga corta (el drawer rinde su summary al abrirse).
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('a[href$="/cart"],a[href*="/cart?"],[data-cart-drawer],[aria-controls*="cart" i],.header__icon--cart,button[name="add"],[type="submit"][name="add"]');
      if (t) burst();
    }, true);
    // Observer ACOTADO al contenedor del drawer (cuando existe) en vez de a todo document.body.
    try {
      var dr = findDrawer();
      var target = dr || document.body;
      var opts = dr ? { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'aria-hidden'] } : { childList: true, subtree: true };
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].type === 'attributes') { burst(); return; }
          var a = muts[i].addedNodes;
          for (var j = 0; j < a.length; j++) {
            var n = a[j];
            if (n.nodeType === 1 && ((n.matches && n.matches('.asyco-drawer-recs')) || (n.querySelector && n.querySelector('.asyco-drawer-recs')))) { refresh(); return; }
          }
        }
      }).observe(target, opts);
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
